export default {
  common: {
    loading: 'កំពុងផ្ទុក',
    confirm: 'អះអាង',
    cancel: 'បោះបង់',
    save: 'រក្សាទុក',
    back: 'ត្រឡប់ក្រោយ',
    copy: 'ចម្លង',
    delete: 'លុប',
    copySuccess: 'ចម្លងបានជោគជ័យ',
    editSuccess: 'កែប្រែបានជោគជ័យ',
    deleteSuccess: 'លុបបានជោគជ័យ',
    modifySuccess: 'ធ្វើបច្ចុប្បន្នភាពបានជោគជ័យ',
    cannotBeEmpty: 'មិនអាចទទេបានទេ',
    noContent: 'គ្មានមាតិកា',
    noData: 'គ្មានទិន្នន័យដែលទាក់ទង',
    noMoreData: 'គ្មានទិន្នន័យបន្ថែមទេ',
    iKnow: 'ខ្ញុំយល់ហើយ',
    selectService: 'ជ្រើសរើសអ្នកផ្ដល់សេវា',
    sendSuccess: 'ផ្ញើរជោគជ័យ',
  },
  billHome: {
    recharge: 'សេវាបញ្ចូលប្រាក់ និងបង់ប្រាក់',
    coupon: 'គូប៉ុង',
    rechargeNow: 'បញ្ចូលប្រាក់ឥឡូវនេះ',
    cost: 'ទូរស័ព្ទ',
    flow: 'ទិន្នន័យ',
    rechargeNotice: 'ព័ត៌មានសំខាន់មុនបញ្ចូលប្រាក់',
    rechargeCost: 'បញ្ចូលប្រាក់ទូរស័ព្ទ',
    rechargeFlow: 'បញ្ចូលទិន្នន័យ',
    rechargeAmount: 'ចំនួនទឹកប្រាក់',
    rechargePackage: 'កញ្ចប់បញ្ចូលប្រាក់',
    discount: 'បានបញ្ចុះតម្លៃ',
    confirmTxt: 'បញ្ជាក់ថាត្រឹមត្រូវ',
    confirmTxt1: 'ខ្ញុំយល់ហើយ',
    actualPayment: 'ទឹកប្រាក់ជាក់ស្តែង',
    selectCoupon: 'ជ្រើសរើសគូប៉ុង',
    useRule: 'លក្ខខណ្ឌប្រើប្រាស់',
    availableCoupon: 'គូប៉ុងអាចប្រើបាន',
    unavailableCoupon: 'គូប៉ុងមិនអាចប្រើបាន',
    noAvailableCoupon: 'មិនមានគូប៉ុងអាចប្រើបាន',
    selectPhone: 'ជ្រើសរើសលេខទូរស័ព្ទ',
    pleaseInputPhone: 'សូមបញ្ចូលលេខទូរស័ព្ទ',
    couponCount: 'សន្លឹកអាចប្រើបាន',
    pleaseInputCorrectPhone: 'សូមបញ្ចូលលេខទូរស័ព្ទឱ្យបានត្រឹមត្រូវ',
    pleaseSelectPackage: 'សូមជ្រើសរើសកញ្ចប់បញ្ចូលទឹកប្រាក់',
  },
  accountManage: {
    title: 'គ្រប់គ្រងគណនី',
    edit: 'កែប្រែ',
    deleteConfirm: 'បញ្ជាក់ការលុប',
  },
  rechargeDetail: {
    title: 'ព័ត៌មានបង់ប្រាក់',
    continuePay: 'បន្តបង់ប្រាក់',
  },
  feesExpense: {
    title: 'ប្រវត្តិបង់ប្រាក់',
    recharge: 'លេខទូរស័ព្ទ',
    electricity: 'ថ្លៃភ្លើង',
    internet: 'ថ្លៃអ៊ីនធឺណិត',
    water: 'ថ្លៃទឹក',
    photo: 'ថតរូប',
    complete: 'រួចរាល់',
    manage: 'គ្រប់គ្រង',
    allSelect: 'ជ្រើសទាំងអស់',
    selected: 'បានជ្រើសរើស',
    deleteConfirm: '',
    deleteRecord: 'លុបទិន្នន័យនេះមែនទេ?',
    noDataAction: 'គ្មានទិន្នន័យសម្រាប់ដំណើរការ',
    pleaseSelect: 'សូមជ្រើសទិន្នន័យដើម្បីលុប',
    feesNotice: 'ព័ត៌មានសំខាន់មុនបង់ប្រាក់',
  },
  formCom: {
    upload: 'ចុចដើម្បីផ្ទុកឡើង',
    saveAccount: 'រក្សាទុកឬអាប់ដេតគណនី',
    createOrder: 'បង្កើតការបញ្ជាទិញ',
    rechargeIng: 'កំពុងបញ្ចូលប្រាក់',
    rechargeNow: 'បញ្ចូលប្រាក់ឥឡូវនេះ',
    serviceProvider: 'អ្នកផ្ដល់សេវា',
    billImage: 'រូបថតវិក្កយបត្រ',
    returnSelect: 'ត្រឡប់ទៅជ្រើសម្ដងទៀត',
    electricity: 'បង់ប្រាក់អគ្គិសនី',
    internet: 'បង់ប្រាក់អ៊ីនធឺណិត',
    water: 'បង់ប្រាក់ទឹក',
    photo: 'បង់ប្រាក់តាមរូបថត',
    life: 'បង់ប្រាក់ប្រចាំថ្ងៃ',
    uploadFail: 'ផ្ទុកឡើងបរាជ័យ សូមសាកល្បងម្តងទៀត',
    pleaseFill: 'សូមបំពេញព័ត៌មានអស់លើក',
    submitSuccess: 'បានដាក់ស្នើដោយជោគជ័យ សូមរងចាំបង់ប្រាក់',
  },
  langPop: {
    selectLang: 'ជ្រើសរើសភាសា',
  },
  loginPop: {
    loginOrRegister: 'សូមចូលគណនីឬចុះឈ្មោះ Kuaizi',
    confirmLogout: 'តើអ្នកប្រាកដថាចង់ចេញមែនទេ?',
    toLogin: 'ចូល',
    logoutSuccess: 'ចេញដោយជោគជ័យ',
  },
  newMe: {
    myOrder: 'ការបញ្ជាទិញរបស់ខ្ញុំ',
    coupon: 'គូប៉ុង',
    accountManage: 'គ្រប់គ្រងគណនី',
    orderCount: 'ការបញ្ជាទិញកំពុងដំណើរការ',
    couponCount: 'សន្លឹក',
    account: 'គណនី',
    logout: 'ចេញ',
  },
  coupons: {
    all: 'ទាំងអស់',
    coupon: 'គូប៉ុង',
    historyCoupon: 'គូប៉ុងដែលបានប្រើ/ផុតកំណត់',
    use: 'ប្រើប្រាស់',
    validityPeriod: 'អាចប្រើបានដល់',
    useRule: 'លក្ខខណ្ឌ',
    used: 'បានប្រើ',
    expired: 'ផុតកំណត់',
  },
  accountSeting: {
    title: 'ការកំណត់',
    personalInfo: 'ព័ត៌មានផ្ទាល់ខ្លួន',
    modifyPayPassword: 'ផ្លាស់ប្ដូរលេខសម្ងាត់ការបង់ប្រាក់',
    modifyLoginPassword: 'ផ្លាស់ប្ដូរលេខសម្ងាត់ចូល',
    phone: 'លេខទូរស័ព្ទ',
    code: 'កូដផ្ទៀងផ្ទាត់',
    loginPassword: 'ពាក្យសម្ងាត់ចូល',
    confirmModify: 'បញ្ជាក់ការផ្លាស់ប្ដូរ',
    noCode: 'មិនទទួលបានកូដ?',
    passwordPlaceholder: 'ពាក្យសម្ងាត់ត្រូវមាន 8–16 តួអក្សរនិងលេខ',
    inputCorrectPhone: 'សូមបញ្ចូលលេខត្រឹមត្រូវ',
    afterGetCode: 'អាចទទួលបានម្តងទៀតបន្ទាប់ពី',
    getCode: 'ទទួលកូដ',
    input6DigitPassword: 'សូមបញ្ចូលលេខសម្ងាត់ 6 ខ្ទង់',
    twoInputPasswordNotConsistent: 'ពាក្យសម្ងាត់មិនត្រូវគ្នា',
    placeholderCode: 'បញ្ចូលកូដផ្ទៀងផ្ទាត់',
    confirmPassword: 'បញ្ជាក់ពាក្យសម្ងាត់',
    password: 'ពាក្យសម្ងាត់',
    submit: 'ដាក់ស្នើ',
    avatar: 'រូបតំណាង',
    userName: 'ឈ្មោះអ្នកប្រើប្រាស់',
    nickName: 'ឈ្មោះហៅក្រៅ',
    modifyPhone: 'ផ្លាស់ប្ដូរលេខទូរស័ព្ទ',
    nickNamePlaceholder: 'បង្ហាញអត្តសញ្ញាណរបស់អ្នក',
    sex: 'ភេទ',
    male: 'បុរស',
    female: 'ស្រី',
    email: 'អ៊ីមែល',
    emailPlaceholder: 'បញ្ចូលអ៊ីមែលសម្រាប់សងបញ្ជីពាក្យសម្ងាត់',
    pleaseCompletePersonalData: 'សូមបំពេញព័ត៌មានផ្ទាល់ខ្លួន ដើម្បីប្រើប្រាស់មុខងារបន្ថែម',
    bindNewPhone: 'ភ្ជាប់លេខថ្មី',
    oldPhone: 'លេខចាស់',
    completeVerification: 'បញ្ចប់ការផ្ទៀងផ្ទាត់',
    changePayPasswordTitle: 'ផ្លាស់ប្ដូរពាក្យសម្ងាត់បង់ប្រាក់',
    changePasswordTitle: 'ផ្លាស់ប្ដូរពាក្យសម្ងាត់',
    oldPhoneTitle: 'ផ្ទៀងផ្ទាត់លេខចាស់',
    editInfoTitle: 'កែប្រែព័ត៌មានផ្ទាល់ខ្លួន',
    areaCode: 'កូដតំបន់',
  },
}
